/* ROTEM+ theme — drawers, toasts, gallery */
(function () {
  const openDrawer = (el) => {
    if (!el) return;
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = (el) => {
    if (!el) return;
    el.classList.remove('is-open');
    if (!document.querySelector('.drawer.is-open')) document.body.style.overflow = '';
  };

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-drawer-open]');
    if (openBtn) {
      openDrawer(document.getElementById(openBtn.getAttribute('data-drawer-open')));
      return;
    }

    const cartBtn = event.target.closest('[data-cart-toggle]');
    if (cartBtn) {
      openDrawer(document.querySelector('[data-cart-drawer]'));
      return;
    }

    const closeBtn = event.target.closest('[data-drawer-close]');
    if (closeBtn) closeDrawer(closeBtn.closest('[data-drawer]'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
    }
  });

  window.rotemDrawer = { open: openDrawer, close: closeDrawer };

  let toastTimer;
  window.rotemToast = function (message) {
    const toast = document.getElementById('rotem-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
  };

  /* Product gallery thumbs */
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-thumb]');
    if (!thumb) return;
    const main = document.getElementById('ProductMainImage');
    if (main) main.src = thumb.getAttribute('data-full');
    document.querySelectorAll('[data-thumb]').forEach((t) => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  });
})();
